var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  viewBox: "0 0 22 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.25 1v12.399L5.48 9.424a.75.75 0 1 0-.96 1.152l6 5a.75.75 0 0 0 .96 0l6-5a.75.75 0 0 0-.96-1.152l-4.77 3.975V1a.75.75 0 0 0-1.5 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.75 16a.75.75 0 0 0-1.5 0v4c0 .414.336.75.75.75h20a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 0-1.5 0v3.25H1.75z"
})));
export default SvgDownload;